"use client";

import { useRouter } from "next/navigation";
import { useLanguage } from "../context/LanguageContext";

export function LanguageSwitcher(): JSX.Element {
  const { locale, setLocale } = useLanguage();
  const router = useRouter();

  const options: Array<["en" | "he", string]> = [
    ["en", "EN"],
    ["he", "HE"]
  ];

  const buildPath = (nextLocale: "en" | "he"): string => {
    if (typeof window === "undefined") return `/${nextLocale}`;

    const url = new URL(window.location.href);
    const segments = url.pathname.split("/").filter(Boolean);
    const currentLocale = segments[0] === "he" ? "he" : "en";
    const rest = segments.slice(1).join("/");
    const nextPath = currentLocale === nextLocale ? url.pathname : `/${nextLocale}${rest ? `/${rest}` : ""}`;
    return `${nextPath}${url.search}`;
  };

  return (
    <div
      className="flex items-center gap-1 rounded-full border border-slate-200 bg-white px-1 py-0.5 text-xs font-semibold shadow-sm transition-colors dark:border-slate-700 dark:bg-slate-900"
      data-testid="toggle-locale"
    >
      {options.map(([key, label]) => {
        const active = locale === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => {
              const target = buildPath(key);
              setLocale(key);
              router.push(target);
            }}
            data-testid={`lang-${key}`}
            className={`rounded-full px-3 py-1 transition-colors ${
              active
                ? "border border-primary-200 bg-primary-50 text-primary-700 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-50"
                : "text-slate-700 transition-colors hover:text-primary-700 dark:text-slate-200 dark:hover:text-primary-100"
            } focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white`}
            aria-pressed={active}
            aria-label={`Switch language to ${key === "en" ? "English" : "Hebrew"}`}
            lang={key}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
